import { render, staticRenderFns } from "./MultipleChoiceElement.vue?vue&type=template&id=3870d9e0&scoped=true&"
import script from "./MultipleChoiceElement.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870d9e0",
  null
  
)

export default component.exports